/**
 * 信息科 “通用字典”
 * 以下的路由是 “通用字典”里面各个字典的路由的配置
 * 包括 11 个字典（“通用字典”中）
 */
const dictionaryRoutes = [
  {
    path: 'dictionary-jibing',
    name: 'dictionary-jibing',
    meta: {
      title: '疾病诊断目录',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-jibing.vue'], resolve)
  },
  {
    path: 'dictionary-shoushu',
    name: 'dictionary-shoushu',
    meta: {
      title: '手术诊断目录',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-shoushu.vue'], resolve)
  },
  {
    path: 'dictionary-yibao',
    name: 'dictionary-yibao',
    meta: {
      title: '病人医保性质',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-yibao.vue'], resolve)
  },
  {
    path: 'universal-dictionary',
    name: 'universal-dictionary',
    meta: {
      title: '通用字典',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace'
      }
    },
    component: resolve => require(['../views/page/info-management/universal-dictionary.vue'], resolve)
  },
  {
    path: 'dictionary-guanxi',
    name: 'dictionary-guanxi',
    meta: {
      title: '关系',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '通用字典',
          path: '/default/universal-dictionary'
        }
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-guanxi.vue'], resolve)
  },
  {
    path: 'dictionary-hunyin',
    name: 'dictionary-hunyin',
    meta: {
      title: '婚姻状况',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '通用字典',
          path: '/default/universal-dictionary'
        }
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-hunyin.vue'], resolve)
  },
  {
    path: 'dictionary-zhenduan',
    name: 'dictionary-zhenduan',
    meta: {
      title: '诊断手段',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '通用字典',
          path: '/default/universal-dictionary'
        }
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-zhenduan.vue'], resolve)
  },
  {
    path: 'dictionary-zhiye',
    name: 'dictionary-zhiye',
    meta: {
      title: '职业',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '通用字典',
          path: '/default/universal-dictionary'
        }
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-zhiye.vue'], resolve)
  },
  {
    path: 'dictionary-zhiwu',
    name: 'dictionary-zhiwu',
    meta: {
      title: '职务',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '通用字典',
          path: '/default/universal-dictionary'
        }
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-zhiwu.vue'], resolve)
  },
  {
    path: 'dictionary-mazuifangshi',
    name: 'dictionary-mazuifangshi',
    meta: {
      title: '麻醉方式',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '通用字典',
          path: '/default/universal-dictionary'
        }
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-mazuifangshi.vue'], resolve)
  },
  {
    path: 'dictionary-fenmianqingkuang',
    name: 'dictionary-fenmianqingkuang',
    meta: {
      title: '分娩情况',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '通用字典',
          path: '/default/universal-dictionary'
        }
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-fenmianqingkuang.vue'], resolve)
  },
  {
    path: 'dictionary-bingrenlaiyuan',
    name: 'dictionary-bingrenlaiyuan',
    meta: {
      title: '病人来源',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '通用字典',
          path: '/default/universal-dictionary'
        }
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-bingrenlaiyuan.vue'], resolve)
  },
  {
    path: 'dictionary-jiaoyushuiping',
    name: 'dictionary-jiaoyushuiping',
    meta: {
      title: '教育水平',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '通用字典',
          path: '/default/universal-dictionary'
        }
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-jiaoyushuiping.vue'], resolve)
  },
  {
    path: 'dictionary-jiesuanleixing',
    name: 'dictionary-jiesuanleixing',
    meta: {
      title: '结算类型',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '通用字典',
          path: '/default/universal-dictionary'
        }
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-jiesuanleixing.vue'], resolve)
  },
  {
    path: 'dictionary-yuangongleixing',
    name: 'dictionary-yuangongleixing',
    meta: {
      title: '员工类型',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '通用字典',
          path: '/default/universal-dictionary'
        }
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-yuangongleixing.vue'], resolve)
  },
  {
    path: 'dictionary-yizhuleixing',
    name: 'dictionary-yizhuleixing',
    meta: {
      title: '医嘱类型',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '通用字典',
          path: '/default/universal-dictionary'
        }
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-yizhuleixing.vue'], resolve)
  },
  {
    path: 'dictionary-yizhutiaomu',
    name: 'dictionary-yizhutiaomu',
    meta: {
      title: '医嘱条目类型',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '通用字典',
          path: '/default/universal-dictionary'
        }
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-yizhutiaomu.vue'], resolve)
  },
  {
    path: 'dictionary-binganzhiliang',
    name: 'dictionary-binganzhiliang',
    meta: {
      title: '病案质量',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '通用字典',
          path: '/default/universal-dictionary'
        }
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-binganzhiliang.vue'], resolve)
  },
  {
    path: 'dictionary-liyuanfangshi',
    name: 'dictionary-liyuanfangshi',
    meta: {
      title: '离院方式',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '通用字典',
          path: '/default/universal-dictionary'
        }
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-liyuanfangshi.vue'], resolve)
  },
  {
    path: 'dictionary-chuyuanzhuangui',
    name: 'dictionary-chuyuanzhuangui',
    meta: {
      title: '出院转归情况',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '通用字典',
          path: '/default/universal-dictionary'
        }
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-chuyuanzhuangui.vue'], resolve)
  },
  {
    path: 'dictionary-ruyuanfangshi',
    name: 'dictionary-ruyuanfangshi',
    meta: {
      title: '入院方式',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '通用字典',
          path: '/default/universal-dictionary'
        }
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-ruyuanfangshi.vue'], resolve)
  },
  {
    path: 'dictionary-yiliaodaiyuleixing',
    name: 'dictionary-yiliaodaiyuleixing',
    meta: {
      title: '医疗待遇类型',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '通用字典',
          path: '/default/universal-dictionary'
        }
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-yiliaodaiyuleixing.vue'], resolve)
  },
  {
    path: 'dictionary-ruyuanzhuangtai',
    name: 'dictionary-ruyuanzhuangtai',
    meta: {
      title: '入院状态',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '通用字典',
          path: '/default/universal-dictionary'
        }
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-ruyuanzhuangtai.vue'], resolve)
  },
  {
    path: 'dictionary-yewuleixing',
    name: 'dictionary-yewuleixing',
    meta: {
      title: '业务类型',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '通用字典',
          path: '/default/universal-dictionary'
        }
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-yewuleixing.vue'], resolve)
  },
  {
    path: 'dictionary-jibingfenxing',
    name: 'dictionary-jibingfenxing',
    meta: {
      title: '疾病分型',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '通用字典',
          path: '/default/universal-dictionary'
        }
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-jibingfenxing'], resolve)
  },
  {
    path: 'dictionary-fangliaofangshi',
    name: 'dictionary-fangliaofangshi',
    meta: {
      title: '放疗方式',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '通用字典',
          path: '/default/universal-dictionary'
        }
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-fangliaofangshi.vue'], resolve)
  },
  {
    path: 'dictionary-fangliaochengxu',
    name: 'dictionary-fangliaochengxu',
    meta: {
      title: '放疗程序',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '通用字典',
          path: '/default/universal-dictionary'
        }
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-fangliaochengxu.vue'], resolve)
  },
  {
    path: 'dictionary-fangliaozhuangzhi',
    name: 'dictionary-fangliaozhuangzhi',
    meta: {
      title: '放疗装置',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '通用字典',
          path: '/default/universal-dictionary'
        }
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-fangliaozhuangzhi.vue'], resolve)
  },
  {
    path: 'dictionary-hualiaofangshi',
    name: 'dictionary-hualiaofangshi',
    meta: {
      title: '化疗方式',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '通用字典',
          path: '/default/universal-dictionary'
        }
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-hualiaofangshi.vue'], resolve)
  },
  {
    path: 'dictionary-hualiaofangfa',
    name: 'dictionary-hualioafangfa',
    meta: {
      title: '化疗方法',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '通用字典',
          path: '/default/universal-dictionary'
        }
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-hualiaofangfa.vue'], resolve)
  },
  {
    path: 'dictionary-zhenduanfangshi',
    name: 'dictionary-zhenduanfangshi',
    meta: {
      title: '诊断方式',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '通用字典',
          path: '/default/universal-dictionary'
        }
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-zhenduanfangshi.vue'], resolve)
  },
  {
    path: 'dictionary-jiesuanleixing',
    name: 'dictionary-jiesuanleixing',
    meta: {
      title: '结算类型',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '通用字典',
          path: '/default/universal-dictionary'
        }
      }
    },
    component: resolve => require(['../views/page/dictionary/dictionary-jiesuanleixing.vue'], resolve)
  }
]

export default dictionaryRoutes
